module.exports = __webpack_public_path__ + "static/img/img-7.bfa30b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-7.png
// module id = kbs4
// module chunks = 1